/**
 * Turns the form's plain payload into multipart FormData.
 *
 * Components always hand the services the same plain object:
 *   { ...scalarFields, customFields: [], images: [], deletedImageIds: [] }
 *
 * Keeping that contract on both the mock and the HTTP path means flipping
 * USE_MOCK never touches component code.
 */
export const buildFormData = (payload = {}) => {
  const { images = [], customFields = [], deletedImageIds = [], ...fields } = payload;

  const formData = new FormData();

  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value === null || value === undefined ? "" : value);
  });

  formData.append("customFields", JSON.stringify(customFields));
  formData.append("deletedImageIds", JSON.stringify(deletedImageIds));

  // One JSON array of image metadata. `fileIndex` says which entry of the
  // `images` file list a row belongs to; null means the image already exists
  // and only its tags changed.
  let fileIndex = 0;
  const imagesMeta = images.map((item, position) => {
    const meta = {
      id: item.id ?? null,
      title: item.title ?? "",
      category: item.category ?? "",
      subCategory: item.subCategory ?? "",
      otherCategory: item.otherCategory ?? "",
      style: item.style ?? "",
      keywords: item.keywords ?? [],
      description: item.description ?? "",
      isDp: Boolean(item.isDp),
      position,
      fileIndex: item.file ? fileIndex : null,
    };
    if (item.file) {
      // The [] suffix is required. Without it PHP does not build an array
      // from repeated field names — it keeps only the last file, so a
      // multi-image save arrives with one entry and every fileIndex past 0
      // points at nothing.
      formData.append("images[]", item.file);
      fileIndex += 1;
    }
    return meta;
  });

  formData.append("imagesMeta", JSON.stringify(imagesMeta));

  return formData;
};

export default buildFormData;
